import { IUserAdsInfo, UserAdsEnum } from "@cai-services";

export const getCurrentChartNumber = (
  adsStatus: IUserAdsInfo[],
  adsConfig,
): number => {
  const chartId = adsStatus?.[0]?.campaignId,

   chartKey = adsConfig.findIndex((config) => config?.campaignId === UserAdsEnum[chartId]);

  return Math.max(+chartKey + 1, 0);
};

export const getRoute = (name: string): string => name?.split("(")[1]?.split(")")[0];
